<template>
  <div v-click-outside="closeDropDown">
    <component class="dropdown" :is="tag" :class="[
      { show: isOpen },
      { 'dropdown': direction === 'down' },
      { 'dropup': direction === 'up' }
    ]" aria-haspopup="true" :aria-expanded="isOpen" @click="toggleDropDown">

      <slot name="title">
        <a class="dropdown-toggle nav-link" :class="{ 'no-caret': hideArrow }" data-toggle="dropdown">
          <i :class="icon"></i>
          <span class="no-icon">{{ title }}</span>
        </a>
      </slot>
    </component>
    <ul v-if="isOpen" class="dropdown-menu" :class="[{ 'dropdown-menu-right': position === 'right' }, { show: isOpen }]">
      <div class="dropdown-notification-header">
        <p><b>Notificações</b></p>
        <p @click="markAllAsRead" class="mark-all-link">Marcar todas como lidas <i class="fas fa-check-double m-0"></i></p>
      </div>
      <slot></slot>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'drop-down-notification',
  props: {
    direction: {
      type: String,
      default: 'down'
    },
    title: String,
    icon: String,
    position: String,
    hideArrow: Boolean,
    tag: {
      type: String,
      default: 'li'
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    toggleDropDown() {
      this.isOpen = !this.isOpen;
      this.$emit('change', this.isOpen);
    },
    closeDropDown() {
      this.isOpen = false;
      this.$emit('change', this.isOpen);
    },
    markAllAsRead() {
      this.$store.dispatch('readAllNotification').then(() => {
        this.$store.dispatch("alerts/success", "Notificações marcadas como lidas com sucesso!");
      });
    }
  }
};
</script>
<style lang="scss">
@import "src/assets/sass/now-ui-dashboard/variables.scss";

.dropdown {
  list-style-type: none;
}

.dropdown .dropdown-toggle {
  cursor: pointer;
}

.dropdown-notification-header {
  display: flex;
  justify-content: space-between;
  padding: 1em;
  font-size: 0.75rem;
  border-bottom: 1px solid #e9ecef;

  .mark-all-link {
    cursor: pointer;

    &:hover {
      color: $secondary-color;
      font-weight: 900;
    }
  }
}
</style>
